"use client";

import { authClient } from "@repo/auth/client";
import { useSession } from "@saas/auth/hooks/use-session";
import { useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";

function GoogleOneTapInner() {
	const searchParams = useSearchParams();
	const redirectTo = searchParams.get("redirectTo");
	const { loaded, user } = useSession();
	const userId = user?.id;

	useEffect(() => {
		if (!loaded || userId) {
			return;
		}

		void authClient
			.oneTap({
				callbackURL: redirectTo
					? new URL(redirectTo, window.location.origin).toString()
					: undefined,
			})
			.catch((error) => {
				console.error("Google One Tap failed:", error);
			});
	}, [loaded, redirectTo, userId]);

	return null;
}

export function GoogleOneTap() {
	return (
		<Suspense fallback={null}>
			<GoogleOneTapInner />
		</Suspense>
	);
}
